import { render, staticRenderFns } from "./WorldViewDetail.vue?vue&type=template&id=64f1614c&scoped=true"
import script from "./WorldViewDetail.vue?vue&type=script&lang=ts"
export * from "./WorldViewDetail.vue?vue&type=script&lang=ts"
import style0 from "./WorldViewDetail.vue?vue&type=style&index=0&id=64f1614c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f1614c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64f1614c')) {
      api.createRecord('64f1614c', component.options)
    } else {
      api.reload('64f1614c', component.options)
    }
    module.hot.accept("./WorldViewDetail.vue?vue&type=template&id=64f1614c&scoped=true", function () {
      api.rerender('64f1614c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/WorldViewDetail.vue"
export default component.exports